<template>
  <div class="auth-page">
    <div class="auth-card">
      <h1>Проверьте почту</h1>
      <p v-if="email">
        Мы отправили письмо с подтверждением на <strong>{{ email }}</strong>.
        Перейдите по ссылке в письме, чтобы активировать аккаунт.
      </p>
      <p v-else>
        Мы отправили письмо с подтверждением. Перейдите по ссылке в письме, чтобы активировать аккаунт.
      </p>
      <p v-if="message" class="success-message">{{ message }}</p>
      <p v-if="error" class="error-message">{{ error }}</p>
      <form v-if="email" @submit.prevent="resend">
        <button class="btn" type="submit" :disabled="loading">
          {{ loading ? 'Отправка...' : 'Отправить письмо повторно' }}
        </button>
      </form>
      <p style="margin-top: 1rem">
        <router-link to="/login">Вернуться ко входу</router-link>
      </p>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useRoute } from 'vue-router'
import { useAuthStore } from '../stores/auth'

const auth = useAuthStore()
const route = useRoute()

const email = ref(route.query.email?.toString() || '')
const loading = ref(false)
const error = ref('')
const message = ref('')

async function resend() {
  loading.value = true
  error.value = ''
  message.value = ''

  try {
    const result = await auth.resendConfirmation(email.value)
    message.value = result.message
  } catch (err) {
    const errors = err.response?.data?.errors
    error.value = Array.isArray(errors) ? errors.join(', ') : 'Не удалось отправить письмо'
  } finally {
    loading.value = false
  }
}
</script>
